import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Meta } from '@df/core/meta/meta';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsContent } from '@icms/core/content';
import { ICmsContentComponentValidationService } from '@icms/core/content/component/icms-content-component-validation.service';
import { NPageSearch } from '../../../search/page-search.interfaces';
import { NPageHeader } from '../../page-header.component';

@Component({
    selector: 'page-header-meganav-menu',
    templateUrl: './page-header-meganav-menu.html',
    styleUrl: './page-header-meganav-menu.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderMeganavMenuComponent extends UiComponent {
    /**
     * Meganav items
     */
    @Input()
    @ICmsContent({
        watchDepth: 0
    })
    content?: NPageHeader.IBlockDataContent;

    /**
     * Group id for toggle service
     */
    readonly toggleGroupId = NPageHeader.MEGANAV_GROUP_ID;

    readonly shopSubmenuToggleGroupId = NPageHeader.SHOP_SUBMENU_GROUP_ID;

    readonly toggleService = inject(ToggleService);
    private meta = inject(Meta);
    private iCmsContentComponentValidationService = inject(ICmsContentComponentValidationService);

    override ngOnInit(): void {
        this.subscriptions.add(this.meta.subscribe(() => this.toggleService.closeGroup(this.toggleGroupId)));
        super.ngOnInit();
    }

    onMouseIn(index: number, shopSubmenu = false): void {
        if (!this.client.isCms && shopSubmenu) {
            this.toggleService.open([this.shopSubmenuToggleGroupId, index]);
        } else if (!this.client.isCms && this.items && this.hasSubmenu(this.items[index])) {
            this.toggleService.open([this.toggleGroupId, index]);
        }
    }

    onMouseOut(index: number, shopSubmenu = false): void {
        if (!this.client.isCms && shopSubmenu) {
            this.toggleService.close([this.shopSubmenuToggleGroupId, index], { delay: 300 });
        } else if (!this.client.isCms) {
            this.toggleService.close([this.toggleGroupId, index], { delay: 300 });
        }
    }

    onShopClick(index: number): void {
        if (this.client.isCms) {
            this.toggleService.toggle([this.shopSubmenuToggleGroupId, index]);
        }
    }

    onClick(toggleId: string, index: number): void {
        if (this.client.isCms) {
            this.toggleService.toggle([toggleId, index]);
        }
    }

    closeMeganav() {
        this.toggleService.closeGroup(NPageHeader.MEGANAV_GROUP_ID, { exceptionItems: [NPageSearch.SEARCH_MEGANAV_KEY] });
    }

    protected get items(): NPageHeader.IMeganavItem[] | undefined {
        return this.content?.meganav;
    }

    /*
     * in icms all can have submenu, outside only when  its set and its valid
     */
    private hasSubmenu(item: NPageHeader.IMeganavItem): boolean {
        return !this.iCmsContentComponentValidationService.getState$(item, undefined, undefined).getValue();
    }
}
